export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

import {bind} from 'kpc';
import {Message} from 'kpc';

export default class extends Component {
    static template = template;
    static defaults() {
        return {
            currentStep: 0,
            showTour: false,
            tourData: [
                {
                    target: '#event-btn1',
                    title: '第一步',
                    content: '点击"下一步"按钮，将触发next事件',
                },
                {
                    target: '#event-btn2',
                    title: '第二步',
                    content: '点击"上一步"按钮，将触发prev事件',
                },
                {
                    target: '#event-btn3',
                    title: '第三步',
                    content: '点击"完成"按钮或关闭图标，将触发finish事件',
                }
            ]
        };
    }

    @bind
    startTour() {
        this.set({
            showTour: true,
            currentStep: 0,
        });
    }

    @bind
    handlePrev(index: number) {
        Message.success(`上一步事件触发: 当前步骤 ${index + 1}`);
    }

    @bind
    handleNext(index: number) {
        Message.success(`下一步事件触发: 当前步骤 ${index + 1}`);
    }

    @bind
    handleFinish() {
        Message.success('引导结束事件触发');
        this.set({
            showTour: false
        });
    }

}